import env from '@/config/env'

// 地图数据
export function getStaticMapLocData(summaryType) {
    // 统计类型 1 交易 2 挂牌
    if (summaryType === 1) {
        return {
            code: 200,
            data: [
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '340000000000',
                    locId: '0',
                    locName: '安徽省',
                    totalAmount: '286.31', // 累计成交额
                    totalArea: null,
                    totalNumber: '3026' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '820000000000',
                    locId: '0',
                    locName: '澳门',
                    totalAmount: '0.21', // 累计成交额
                    totalArea: null,
                    totalNumber: '0' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '110000000000',
                    locId: '0',
                    locName: '北京市',
                    totalAmount: '123.62', // 累计成交额
                    totalArea: null,
                    totalNumber: '4339' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '350000000000',
                    locId: '0',
                    locName: '福建省',
                    totalAmount: '10.86', // 累计成交额
                    totalArea: null,
                    totalNumber: '677' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '620000000000',
                    locId: '0',
                    locName: '甘肃省',
                    totalAmount: '12.35', // 累计成交额
                    totalArea: null,
                    totalNumber: '452' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '440000000000',
                    locId: '0',
                    locName: '广东省',
                    totalAmount: '278.93', // 累计成交额
                    totalArea: null,
                    totalNumber: '9308' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '450000000000',
                    locId: '0',
                    locName: '广西壮族自治区',
                    totalAmount: '74.96', // 累计成交额
                    totalArea: null,
                    totalNumber: '2236' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '520000000000',
                    locId: '0',
                    locName: '贵州省',
                    totalAmount: '33.46', // 累计成交额
                    totalArea: null,
                    totalNumber: '404' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '460000000000',
                    locId: env.HNSLOCID,
                    locName: '海南省',
                    totalAmount: '5.49', // 累计成交额
                    totalArea: null,
                    totalNumber: '437' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '130000000000',
                    locId: '0',
                    locName: '河北省',
                    totalAmount: '1340.23', // 累计成交额
                    totalArea: null,
                    totalNumber: '3430' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '410000000000',
                    locId: '0',
                    locName: '河南省',
                    totalAmount: '230.84', // 累计成交额
                    totalArea: null,
                    totalNumber: '3098' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '230000000000',
                    locId: '0',
                    locName: '黑龙江省',
                    totalAmount: '132.15', // 累计成交额
                    totalArea: null,
                    totalNumber: '1512' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '420000000000',
                    locId: '0',
                    locName: '湖北省',
                    totalAmount: '41.90', // 累计成交额
                    totalArea: null,
                    totalNumber: '2685' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '430000000000',
                    locId: env.HNLOCID,
                    locName: '湖南省',
                    totalAmount: '99.72', // 累计成交额
                    totalArea: null,
                    totalNumber: '30011' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '220000000000',
                    locId: '0',
                    locName: '吉林省',
                    totalAmount: '103.62', // 累计成交额
                    totalArea: null,
                    totalNumber: '960' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '320000000000',
                    locId: '0',
                    locName: '江苏省',
                    totalAmount: '258.73', // 累计成交额
                    totalArea: null,
                    totalNumber: '5370' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '360000000000',
                    locId: '0',
                    locName: '江西省',
                    totalAmount: '43.08', // 累计成交额
                    totalArea: null,
                    totalNumber: '2355' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '210000000000',
                    locId: '0',
                    locName: '辽宁省',
                    totalAmount: '98.71', // 累计成交额
                    totalArea: null,
                    totalNumber: '1542' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '150000000000',
                    locId: '0',
                    locName: '内蒙古自治区',
                    totalAmount: '555.10', // 累计成交额
                    totalArea: null,
                    totalNumber: '2058' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '640000000000',
                    locId: '0',
                    locName: '宁夏回族自治区',
                    totalAmount: '7.89', // 累计成交额
                    totalArea: null,
                    totalNumber: '328' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '630000000000',
                    locId: '0',
                    locName: '青海省',
                    totalAmount: '1.05', // 累计成交额
                    totalArea: null,
                    totalNumber: '138' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '370000000000',
                    locId: '0',
                    locName: '山东省',
                    totalAmount: '608.58', // 累计成交额
                    totalArea: null,
                    totalNumber: '8676' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '140000000000',
                    locId: '0',
                    locName: '山西省',
                    totalAmount: '54.58', // 累计成交额
                    totalArea: null,
                    totalNumber: '1228' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '610000000000',
                    locId: '0',
                    locName: '陕西省',
                    totalAmount: '109.08', // 累计成交额
                    totalArea: null,
                    totalNumber: '1570' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '310000000000',
                    locId: '0',
                    locName: '上海市',
                    totalAmount: '9.10', // 累计成交额
                    totalArea: null,
                    totalNumber: '3420' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '510000000000',
                    locId: '0',
                    locName: '四川省',
                    totalAmount: '125.10', // 累计成交额
                    totalArea: null,
                    totalNumber: '3171' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '710000000000',
                    locId: '0',
                    locName: '台湾省',
                    totalAmount: '125.72', // 累计成交额
                    totalArea: null,
                    totalNumber: '4' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '120000000000',
                    locId: '0',
                    locName: '天津市',
                    totalAmount: '5.62', // 累计成交额
                    totalArea: null,
                    totalNumber: '1794' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '540000000000',
                    locId: '0',
                    locName: '西藏自治区',
                    totalAmount: '0.27', // 累计成交额
                    totalArea: null,
                    totalNumber: '26' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '810000000000',
                    locId: '0',
                    locName: '香港特别行政区',
                    totalAmount: '0.44', // 累计成交额
                    totalArea: null,
                    totalNumber: '5' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '650000000000',
                    locId: '0',
                    locName: '新疆维吾尔自治区',
                    totalAmount: '99.48', // 累计成交额
                    totalArea: null,
                    totalNumber: '1258' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '530000000000',
                    locId: '0',
                    locName: '云南省',
                    totalAmount: '77.39', // 累计成交额
                    totalArea: null,
                    totalNumber: '1456' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '330000000000',
                    locId: '0',
                    locName: '浙江省',
                    totalAmount: '12.37', // 累计成交额
                    totalArea: null,
                    totalNumber: '1583' // 累计成交笔数
                },
                {
                    highStandardFarmlandArea: '0.00',
                    locCode: '500000000000',
                    locId: '0',
                    locName: '重庆市',
                    totalAmount: '15.84', // 累计成交额
                    totalArea: null,
                    totalNumber: '1346.0' // 累计成交笔数
                }
            ]
        }
    } else {
        return {
            code: 200,
            data: [
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '340000000000',
                    locId: '0',
                    locName: '安徽省',
                    totalAmount: '0.00',
                    totalArea: '8931200.66', // 挂牌面积
                    totalNumber: '7565' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '820000000000',
                    locId: '0',
                    locName: '澳门',
                    totalAmount: '0.00',
                    totalArea: '3.00', // 挂牌面积
                    totalNumber: '2' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '110000000000',
                    locId: '0',
                    locName: '北京',
                    totalAmount: '0.00',
                    totalArea: '11104583.82', // 挂牌面积
                    totalNumber: '10248' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '350000000000',
                    locId: '0',
                    locName: '福建省',
                    totalAmount: '0.00',
                    totalArea: '702722.67', // 挂牌面积
                    totalNumber: '3176' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '620000000000',
                    locId: '0',
                    locName: '甘肃省',
                    totalAmount: '0.00',
                    totalArea: '1449930.16', // 挂牌面积
                    totalNumber: '1360' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '440000000000',
                    locId: '0',
                    locName: '广东省',
                    totalAmount: '0.00',
                    totalArea: '15681258.91', // 挂牌面积
                    totalNumber: '23269' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '450000000000',
                    locId: '0',
                    locName: '广西壮族自治区',
                    totalAmount: '0.00',
                    totalArea: '5020475.43', // 挂牌面积
                    totalNumber: '5898' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '520000000000',
                    locId: '0',
                    locName: '贵州省',
                    totalAmount: '0.00',
                    totalArea: '1770570.58', // 挂牌面积
                    totalNumber: '1847' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '460000000000',
                    locId: env.HNSLOCID,
                    locName: '海南省',
                    totalAmount: '0.00',
                    totalArea: '3063.86', // 挂牌面积
                    totalNumber: '16' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '130000000000',
                    locId: '0',
                    locName: '河北省',
                    totalAmount: '0.00',
                    totalArea: '14971548.43', // 挂牌面积
                    totalNumber: '8576' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '410000000000',
                    locId: '0',
                    locName: '河南省',
                    totalAmount: '0.00',
                    totalArea: '7615326.54', // 挂牌面积
                    totalNumber: '7745' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '230000000000',
                    locId: '0',
                    locName: '黑龙江省',
                    totalAmount: '0.00',
                    totalArea: '10360502.81', // 挂牌面积
                    totalNumber: '5205' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '420000000000',
                    locId: '0',
                    locName: '湖北省',
                    totalAmount: '0.00',
                    totalArea: '4831722.89', // 挂牌面积
                    totalNumber: '9967' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '430000000000',
                    locId: env.HNLOCID,
                    locName: '湖南省',
                    totalAmount: '0.00',
                    totalArea: '3854769.65', // 挂牌面积
                    totalNumber: '69061' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '220000000000',
                    locId: '0',
                    locName: '吉林省',
                    totalAmount: '0.00',
                    totalArea: '11430710.57', // 挂牌面积
                    totalNumber: '5311' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '320000000000',
                    locId: '0',
                    locName: '江苏省',
                    totalAmount: '0.00',
                    totalArea: '5089881.34', // 挂牌面积
                    totalNumber: '17900' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '360000000000',
                    locId: '0',
                    locName: '江西省',
                    totalAmount: '0.00',
                    totalArea: '4020798.88', // 挂牌面积
                    totalNumber: '12882' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '210000000000',
                    locId: '0',
                    locName: '辽宁省',
                    totalAmount: '0.00',
                    totalArea: '7048900.42', // 挂牌面积
                    totalNumber: '11155' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '150000000000',
                    locId: '0',
                    locName: '内蒙古自治区',
                    totalAmount: '0.00',
                    totalArea: '31602983.16', // 挂牌面积
                    totalNumber: '6859' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '640000000000',
                    locId: '0',
                    locName: '宁夏回族自治区',
                    totalAmount: '0.00',
                    totalArea: '655225.39', // 挂牌面积
                    totalNumber: '751' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '630000000000',
                    locId: '0',
                    locName: '青海省',
                    totalAmount: '0.00',
                    totalArea: '246159.71', // 挂牌面积
                    totalNumber: '469' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '370000000000',
                    locId: '0',
                    locName: '山东省',
                    totalAmount: '0.00',
                    totalArea: '21295860.14', // 挂牌面积
                    totalNumber: '21690' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '140000000000',
                    locId: '0',
                    locName: '山西省',
                    totalAmount: '0.00',
                    totalArea: '4394363.12', // 挂牌面积
                    totalNumber: '3273' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '610000000000',
                    locId: '0',
                    locName: '陕西省',
                    totalAmount: '0.00',
                    totalArea: '6070771.56', // 挂牌面积
                    totalNumber: '4081' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '310000000000',
                    locId: '0',
                    locName: '上海市',
                    totalAmount: '0.00',
                    totalArea: '1223562.98', // 挂牌面积
                    totalNumber: '7794' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '510000000000',
                    locId: '0',
                    locName: '四川省',
                    totalAmount: '0.00',
                    totalArea: '8736736.76', // 挂牌面积
                    totalNumber: '10546' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '710000000000',
                    locId: '0',
                    locName: '台湾省',
                    totalAmount: '0.00',
                    totalArea: '20972.33', // 挂牌面积
                    totalNumber: '12' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '0.00', // 高标准农田建设面积
                    locCode: '120000000000',
                    locId: '0',
                    locName: '天津市',
                    totalAmount: '0.00',
                    totalArea: '1002223.39', // 挂牌面积
                    totalNumber: '5660' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '', // 高标准农田建设面积
                    locCode: '540000000000',
                    locId: '0',
                    locName: '西藏自治区',
                    totalAmount: '0.00',
                    totalArea: '18859.17', // 挂牌面积
                    totalNumber: '79' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '', // 高标准农田建设面积
                    locCode: '810000000000',
                    locId: '0',
                    locName: '香港特别行政区',
                    totalAmount: '0.00',
                    totalArea: '8563.45', // 挂牌面积
                    totalNumber: '13' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '', // 高标准农田建设面积
                    locCode: '650000000000',
                    locId: '0',
                    locName: '新疆维吾尔自治区',
                    totalAmount: '0.00',
                    totalArea: '6472588.63', // 挂牌面积
                    totalNumber: '3008' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '', // 高标准农田建设面积
                    locCode: '530000000000',
                    locId: '0',
                    locName: '云南省',
                    totalAmount: '0.00',
                    totalArea: '6173033.47', // 挂牌面积
                    totalNumber: '5539' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '', // 高标准农田建设面积
                    locCode: '330000000000',
                    locId: '0',
                    locName: '浙江省',
                    totalAmount: '0.00',
                    totalArea: '1534536.34', // 挂牌面积
                    totalNumber: '14922' // 挂牌数量
                },
                {
                    highStandardFarmlandArea: '', // 高标准农田建设面积
                    locCode: '500000000000',
                    locId: '0',
                    locName: '重庆市',
                    totalAmount: '0.00',
                    totalArea: '2210838.93', // 挂牌面积
                    totalNumber: '7133' // 挂牌数量
                }
            ]
        }
    }
}
// 累计
export function getStaticTotalSummary() {
    return {
        code: 200,
        data: {
            auctionTotalAmount: '550.03',
            auctionTotalNumber: '9381',
            agreementTotalAmount: '1549.57',
            agreementTotalNumber: '26430',
            historyTotalAmount: '2900.63',
            historyTotalNumber: '49474',
            totalAmount: '5000.23',
            totalNumber: '85285',

            siteBigScreenTotalArea: ''
        }
    }
}
// 金额
export function getStaticTradeAmountSummary(summaryType) {
    if (summaryType === 1) {
        return {
            code: 200,
            data: {
                tradeAmount_TDJYQ: '11856872.13',
                tradeAmount_JTZYXZC: '8035010.20',
                tradeAmount_ZJD: '41138.66',
                tradeAmount_JTJYZC_FW: '10384259',
                tradeAmount_JTJYZC_SP: '3094837',
                tradeAmount_JTJYZC_JQSB: '654',
                tradeAmount_JTJYZC_YSGJ: '1923'
            }
        }
    } else {
        return {
            code: 200,
            data: {
                tradeAmount_TDJYQ: '29813258.46',
                tradeAmount_JTZYXZC: '11109676.27',
                tradeAmount_ZJD: '102846.65',
                tradeAmount_JTJYZC_FW: '29371146',
                tradeAmount_JTJYZC_SP: '6743677',
                tradeAmount_JTJYZC_JQSB: '1245',
                tradeAmount_JTJYZC_YSGJ: '2456'
            }
        }
    }
}
// 面积
export function getStaticLargeScreenAreaStatistics(summaryType) {
    if (summaryType === 1) {
        return {
            code: 200,
            data: {
                tdjyq: '39522907.11',
                jtzyxzc: '44638945.54',
                zjd: '8380139.63'
            }
        }
    } else {
        return {
            code: 200,
            data: {
                tdjyq: '99377528.18',
                jtzyxzc: '61720423.72',
                zjd: '38091543.79'
            }
        }
    }
}
// 笔数
export function getStaticLargeScreenItemStatistics(summaryType) {
    if (summaryType === 1) {
        return {
            code: 200,
            data: {
                tdjyq: '28237',
                jtzyxzc: '29242',
                zjd: '2259',
                expandVoList: [
                    {
                        unitName: '平方米',
                        number: '3461449233',
                        count: '981',
                        typeName: '房屋',
                        typeId: '50'
                    },
                    {
                        unitName: '平方米',
                        number: '1031617766',
                        count: '450',
                        typeName: '商铺',
                        typeId: '52'
                    },
                    {
                        unitName: '辆',
                        number: '1899',
                        count: '1720',
                        typeName: '运输工具',
                        typeId: '53'
                    },
                    {
                        unitName: '台',
                        number: '1756',
                        count: '1523',
                        typeName: '机器设备',
                        typeId: '54'
                    }
                ],

                gq: '11',
                gytdcbjyq: '0',
                gyzc: '0',
                isDeal: null,
                jtjyxjsyd: '0',
                jtjyzc: '25',
                lq: '10'
            }
        }
    } else {
        return {
            code: 200,
            data: {
                tdjyq: '79813',
                jtzyxzc: '44951',
                zjd: '7532',
                expandVoList: [
                    {
                        unitName: '平方米',
                        number: '8920823225',
                        count: '58946',
                        typeName: '房屋',
                        typeId: '50'
                    },
                    {
                        unitName: '平方米',
                        number: '3787455983',
                        count: '27039',
                        typeName: '商铺',
                        typeId: '52'
                    },
                    {
                        unitName: '辆',
                        number: '3689',
                        count: '3145',
                        typeName: '运输工具',
                        typeId: '53'
                    },
                    {
                        unitName: '台',
                        number: '3314',
                        count: '2974',
                        typeName: '机器设备',
                        typeId: '54'
                    }
                ]
            }
        }
    }
}
